export default {
  title: "Preguntas frecuentes",
  subtitle: "Respuestas a las dudas más comunes sobre el uso de la plataforma.",
  contactNote: "Si tu duda no está resuelta, escríbenos a",
  categories: {
    all: "Todas",
    cuenta: "Cuenta y acceso",
    wallet: "Wallet y seguridad",
    ine: "Verificación de INE",
    candidatura: "Candidatura",
    suscripcion: "Membresía y cobros",
    soporte: "Soporte técnico",
  },
}
